export const MAIN_NAVIGATION_PATH_ELEMENTS = {
  profile: 'profile',
  admin: 'admin',
  develop: 'develop',
  controllPanel: 'user-controll-panel',
  statisticsOverview: 'statistics-overview',
  userDetails: 'user-details',
  legalNotice: 'legal-notice',
  privacyPolicy: 'privacy-policy',
  jointResponsibilityAgreement: 'joint-responsibility-agreement',
};

export const MAIN_NAVIGATION_PATHS = {
  legalNotice: `${MAIN_NAVIGATION_PATH_ELEMENTS.legalNotice}`,
  privacyPolicy: `${MAIN_NAVIGATION_PATH_ELEMENTS.privacyPolicy}`,
  jointResponsibilityAgreement: `${MAIN_NAVIGATION_PATH_ELEMENTS.jointResponsibilityAgreement}`,
  profile: `/${MAIN_NAVIGATION_PATH_ELEMENTS.profile}`,
  admin: `/${MAIN_NAVIGATION_PATH_ELEMENTS.admin}`,
  develop: `/${MAIN_NAVIGATION_PATH_ELEMENTS.develop}`,
  userDetails: `/${MAIN_NAVIGATION_PATH_ELEMENTS.admin}/${MAIN_NAVIGATION_PATH_ELEMENTS.userDetails}`,
  statisticsOverview: `/${MAIN_NAVIGATION_PATH_ELEMENTS.admin}/${MAIN_NAVIGATION_PATH_ELEMENTS.statisticsOverview}`,
  userControllPanel: `/${MAIN_NAVIGATION_PATH_ELEMENTS.develop}/${MAIN_NAVIGATION_PATH_ELEMENTS.controllPanel}`,
};
